import {useState, useCallback, useEffect} from 'react';
import PaletteChoice from '../PaletteChoice';
import * as SharedAcross from '../utilities/SharedAcross';
import OwnColor from '../Editor/OwnColor';
import * as ActionModifiers from '../ActionModifiers';

function App(props) {

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var incrementCounter = props.incrementCounter;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var modOptions = props.modOptions;
  var counter = props.counter;
  var palette = props.palette;
  var height = props.height;


  var notSelectedP = palette.filter((aPalette, index)=>{
    return aPalette.v[1].v
  })

  var colorSet = false;
  palette.forEach((aColor, index)=>{
    var isThis = (aColor.v[0].v === colorCombo);
    if (isThis){
      colorSet = aColor;
    }
  })

  const handleUserKeyPress = useCallback(event => {
      const { keyCode } = event;
      if (keyCode === 38){
        doUp();
        event.preventDefault();
      }else if (keyCode === 40){
        doDown();
        event.preventDefault();
      }
  }, [colorCombo, counter]);

  useEffect(() => {
      window.addEventListener('keydown', handleUserKeyPress);
      return () => {
          window.removeEventListener('keydown', handleUserKeyPress);
      };
  }, [handleUserKeyPress]);

  const [coloringWhat, setColoringWhat] = useState(-1);

  function doUp(){
    if (colorCombo === 0){
      setColorCombo(notSelectedP[notSelectedP.length - 1].v[0].v);
    }else{
      var prev = 0;
      for (var i = 0; i < notSelectedP.length; i++){
        var thisP = notSelectedP[i].v[0].v;
        if (thisP === colorCombo){
          break;
        }else{
          prev = thisP;
        }
      }
      setColorCombo(prev);

    }
    incrementCounter();
  }

  function doDown(){
    var prev = 0;
    for (var i = notSelectedP.length - 1; i > -1; i--){
      var thisP = notSelectedP[i].v[0].v;
      if (thisP === colorCombo){
        break;
      }else{
        prev = thisP;
      }
    }
    setColorCombo(prev);
    incrementCounter();
  }



  function changeCP(x){
    return function(e){
      console.log(x);
      setColorCombo(x);
      incrementCounter();
    }
  }

  function nullFn(e){

  }

  function clickColorWhat(x){
    return function(e){
      setColoringWhat(x);
    }
  }

  function clickColor1(iX){
    return function(x){
      customColorRecord[iX] = x;
      setCustomColorRecord({...customColorRecord});
      incrementCounter();
    }
  }


    var ins;
    var ins1;
    if (isShowingCustom){
      var pp = [];

      var modOptionsNon = modOptions.filter((aMod, index)=>{
        return aMod.t.indexOf('buttonColor_') !== 0
      })

      for (var iX = 1; iX < 8; iX++){
        var isInside = false;
        var iXString = iX + '';
        for (var j = 0; j < modOptionsNon.length; j++){
          var aJ = modOptionsNon[j].t.split('_')[1];
          if (aJ === iXString){
            isInside = true;
            break;
          }
        }

        if (isInside){
          var onSelectPiece;
          if (coloringWhat === iX){
            var thisCol = null;
            if (customColorRecord[iX + ''] === false){
            }else{
              thisCol = {t:'C', v:customColorRecord[iX+'']};
            }
            var cc = {};
            cc.cp = {};
            onSelectPiece = <OwnColor submitColor={clickColor1(iXString)} currentStyle={thisCol} currentList={cc} allowFormula={false} e={false} hideRGB={true} width={180} mostRecentColor={''} setMostRecentColor={nullFn}/>
          }else{
            var def = null;
            var ss = {backgroundColor:customColorRecord[iXString], border:'1px solid black', width:180};
            if (customColorRecord[iXString]){
              ss.height = 20;
            }else{
              def = 'Default'
            }
            onSelectPiece = <div style={ss} onClick={clickColorWhat(iX)}>{def}</div>
          }
  //
          pp.push(<div key={iX} style={{marginLeft:'10px'}}>Color {iX}<br/>{onSelectPiece}</div>)
//
        }
      }

      function clickButtonStyle(iX, x){
        return function(e){
          customColorRecord[iX] = x;
          setCustomColorRecord({...customColorRecord});
          incrementCounter();          
        }
      }

      var modOptionsYes = modOptions.filter((aMod, index)=>{
        return aMod.t.indexOf('buttonColor_') === 0
      })

      for (var iY = 8; iY < 12; iY++){
        var isInside1 = false;
        var iYString1 = (iY - 7) + '';
        for (var j1 = 0; j1 < modOptionsYes.length; j1++){
          var aJ1 = modOptionsYes[j1].t.split('_')[1];
          if (aJ1 === iYString1){
            isInside1 = true;
            break;
          }
        }
//
        if (isInside1){
          var onSelectPiece1;
          if (coloringWhat === iX){
            var buttonStyles = SharedAcross.buttonStyles();
            onSelectPiece1 = buttonStyles.map((aButtonStyle, index)=>{
              return <div className={'btn btn-'+aButtonStyle.i} key={index} onClick={clickButtonStyle(iY, aButtonStyle.i)}>A</div>
            })
//
          }else{
            if (customColorRecord[iY+'']){
              onSelectPiece1 = <div className={'btn btn-'+customColorRecord[iY+'']} onClick={clickColorWhat(iY)}>A</div>
            }else{
              onSelectPiece1 = <div style={{border:'1px solid black'}} onClick={clickColorWhat(iY)}>Default</div>

            }
//
          }

          pp.push(<div key={iY} style={{marginLeft:'10px'}}>Button {iYString1}<br/>{onSelectPiece1}</div>)
//
        }
      }


      ins1 = <div>{pp}</div>
//      
    }else{
      var ogStyle = {width:'80%', marginBottom:'20px', cursor:'pointer', border:'1px solid black'};
      if (colorCombo === 0){
        ogStyle.border = '3px solid black';
      }
      ins = <div style={ogStyle} onClick={changeCP(0)}><p className='lead mb-0'>Original</p></div>
      ins1 = <PaletteChoice palette1={notSelectedP} changeCP={changeCP} cp={{}} toHighlight={colorCombo} />
    }
//

    function clickPresetToggle(e){
      if (!isShowingCustom){
        var cust = ActionModifiers.createNull();  
        if (colorSet){
          for (var i = 1; i < 11; i++){
            cust[i+''] = colorSet.v[i+1].v;
          }
        }
        setCustomColorRecord(cust);
      }
      setIsShowingCustom(!isShowingCustom)
      incrementCounter();
    }

    var customToggle;
    if (isShowingCustom){
      customToggle = 'Use Pre-set Colors'
    }else{
      customToggle = 'Use Custom Colors'
    }
//      
    return <td style={{width:200, verticalAlign:'top'}}><div style={{height, overflowY:'scroll'}}><center>{ins}{ins1}<br/><span className='lead mb-0' style={{cursor:'pointer', textDecoration:'underline'}} onClick={clickPresetToggle}>{customToggle}</span></center></div></td>
//  
}

export default App;
